import { RootState } from '../rootReducer';
import { FloatingButtonType, ImageWrapper, VideoWrapper, WaitCursor } from './actions';

export const getFloatingButtons = (state: RootState): Array<FloatingButtonType> => state.components.floatingButton;
export const getWaitCursorState = (state: RootState): WaitCursor => state.components.waitCursor;
export const getImageWrapperState = (state: RootState): ImageWrapper => state.components.imageWrapper;
export const getVideoWrapperState = (state: RootState): VideoWrapper => state.components.videoWrapper;
